export const customerImages = [
  "/customer-banner-1.webp",
  "/customer-banner-2.webp",
  "/customer-banner-3.webp",
];

export const mealProviderImages = [
  "/mealProvider-banner-1.webp",
  "/mealProvider-banner-2.webp",
  "/mealProvider-banner-3.webp",
];
